import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook for language management
 * Provides translation function and language switching utilities
 */
export const useLanguage = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = (i18n.resolvedLanguage || i18n.language || 'es').split('-')[0];

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = currentLanguage;
    }
  }, [currentLanguage]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  
  const languages = [
    { code: 'es', name: 'Español', flag: '/flags/es.svg' },
    { code: 'en', name: 'English', flag: '/flags/us.svg' }
  ];

  const getCurrentLanguageName = () => {
    const lang = languages.find(l => l.code === currentLanguage);
    return lang ? lang.name : 'Español';
  };

  return {
    t,
    changeLanguage,
    currentLanguage,
    languages,
    getCurrentLanguageName
  };
};
